import sortByName from './sortByName';
export default sortByName;
